import React from 'react';
import { useRouteError, Link } from 'react-router-dom';
import { Container, Alert, Button } from 'react-bootstrap';

function ErrorBoundary() {
  const error = useRouteError();

  return (
    <Container className="py-5">
      <Alert variant="danger">
        <Alert.Heading>Oops! Something went wrong</Alert.Heading>
        <p>
          {error?.message || 'An unexpected error occurred'}
        </p>
        <hr />
        <div className="d-flex justify-content-end">
          <Button as={Link} to="/" variant="outline-danger">
            Return to Home
          </Button>
        </div>
      </Alert>
    </Container>
  );
}

export default ErrorBoundary; 